module.exports = __webpack_public_path__ + "img/reject-gray.5f6cd07c.svg";